import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import makeStyles from '@mui/styles/makeStyles';
import arrayMutators from 'final-form-arrays';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { ConnectedProps, connect } from 'react-redux';

import { notify } from '@/actions/ui';
import FAIcon from '@/components/Icon/FAIcon';
import IconMenu from '@/components/IconMenu';
import { Trigger, updateConsultation } from '@/consultation/store';
import { apiErrorMessage } from '@/core/api';
import RequestDetails from '@/expertrequest/components/ExpertRequestForm/DetailsNew';
import SubmitContainer from '@/expertrequest/components/ExpertRequestForm/SubmitContainer';
import { fetchExpertRequests, saveExpertRequest } from '@/expertrequest/store';
import { darkBrown } from '@/theme/colors';

import AttachToExpertRequest from '../AttachToExpertRequest';
import AttachToExpertRequestBanner from '../AttachToExpertRequestBanner';

const useStyles = makeStyles((theme) => ({
  promo: {
    flex: '0 0 360px',
    // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  details: {
    flex: '0 0 360px',
    // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
    [theme.breakpoints.down('lg')]: {
      flex: '0 0 320px',
    },
    // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
}));

interface ExpertRequestDetailsProps {
  consultation: any;
  isViewerExpert: boolean;
  isMobileVersion?: boolean;
}

const connector = connect(undefined, {
  notify,
  fetchExpertRequests,
  saveExpertRequest,
  updateConsultation,
});

const ExpertRequestDetails = ({
  consultation,
  isViewerExpert,
  isMobileVersion,
  notify,
  fetchExpertRequests,
  saveExpertRequest,
  updateConsultation,
}: ExpertRequestDetailsProps & ConnectedProps<typeof connector>) => {
  const s = useStyles();
  const { expert_request: expertRequest } = consultation;
  const canAttachToExpertRequest = !isViewerExpert;

  const [openAttachToExpertRequest, setOpenAttachToExpertRequest] = useState(false);
  const [editRequest, setEditRequest] = useState(false);

  const handleRequestExpertRequestAttach = () => {
    const { expert_request: expertRequest } = consultation;

    fetchExpertRequests({ withGroupOnly: !expertRequest }).then(() =>
      setOpenAttachToExpertRequest(true)
    );
  };

  const handleAttachToExpertRequest = ({ expert_request_id }: any = {}) => {
    return updateConsultation({
      id: consultation.id,
      expert_request_id,
      trigger: Trigger.consultationPage,
    })
      .then(() => {
        const msg =
          expert_request_id === ''
            ? 'Successfully removed Expert Request from Consultation'
            : 'Successfully added Expert Request to Consultation';
        notify(msg, 'success');
        setOpenAttachToExpertRequest(false);
      })
      .catch((ex: any) => {
        notify(apiErrorMessage(ex, 'An error occurred when updating the consultation.'), 'error');
      });
  };

  const handleExpertRequestRemove = () => handleAttachToExpertRequest({ expert_request_id: '' });

  const handleExpertRequestEdit = () => {
    setEditRequest(true);
  };

  const handleExpertRequestGo = () => {
    if (expertRequest) {
      const win = window.open(`/expert_request/${expertRequest.id}`, '_blank');
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      win.focus();
    }
  };

  const handleExpertRequestSave = async (values: any) => {
    setEditRequest(false);
    const { expert_request: expertRequest } = consultation;
    const permissions = expertRequest.permissions || [];
    const canEditQueries = permissions.includes('update_queries');

    try {
      await saveExpertRequest(values, { includeQueries: canEditQueries });
    } catch (e) {
      console.warn(e);
      notify(apiErrorMessage(e, 'An error occurred when updating the expert request.'), 'error');
      return;
    }
    notify('Saved successfully.', 'success');
  };

  let showRequestFields: any;
  let hideRequestFields: any;
  if (isViewerExpert) {
    // experts can only see these fields
    showRequestFields = [
      'name',
      'description',
      'opportunity_location',
      'job_scope',
      'qualifications',
      'questions',
      'sectors',
      'regions',
      'focusAreas',
      'attachments',
    ];
  } else {
    // exclude these fields from ER details via Consultation page
    hideRequestFields = ['project'];
  }

  const requestContextActions = [
    // @ts-expect-error TS(2774) FIXME: This condition will always return true since this ... Remove this comment to see the full error message
    ...(handleExpertRequestEdit
      ? [
          {
            text: 'Go To Expert Request',
            onClick: handleExpertRequestGo,
          },
        ]
      : []),
    ...(handleExpertRequestEdit
      ? [
          {
            text: 'Edit Associated Expert Request',
            onClick: handleExpertRequestEdit,
          },
        ]
      : []),
    ...(handleExpertRequestRemove
      ? [
          {
            text: 'Remove Expert Request',
            onClick: handleExpertRequestRemove,
          },
        ]
      : []),
  ];

  let content = null;
  if (!expertRequest) {
    content = canAttachToExpertRequest && (
      <div className={s.promo}>
        <AttachToExpertRequestBanner
          className={s.details}
          consultation={consultation}
          onRequestExpertRequestAttach={handleRequestExpertRequestAttach}
        />
      </div>
    );
  } else {
    content = (
      <div style={{ flexDirection: 'row' }}>
        {!isViewerExpert && (
          <div style={{ textAlign: 'right', margin: '0 20px -40px' }}>
            <IconMenu iconElement={<FAIcon icon="cog" color={darkBrown} />}>
              {requestContextActions.map((a) => (
                <MenuItem
                  key={a.text}
                  onClick={a.onClick}
                  // @ts-expect-error TS(2339) FIXME: Property 'disabled' does not exist on type '{ text... Remove this comment to see the full error message
                  disabled={a.disabled}
                >
                  {a.text}
                </MenuItem>
              ))}
            </IconMenu>
          </div>
        )}
        <Form
          onSubmit={handleExpertRequestSave}
          initialValues={expertRequest}
          mutators={{
            ...arrayMutators,
          }}
        >
          {({ handleSubmit, form, values }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={4}>
                <Grid item md={isViewerExpert ? 12 : 8} sm={12}>
                  <RequestDetails
                    isViewerExpert={isViewerExpert}
                    showFields={showRequestFields}
                    hideFields={hideRequestFields}
                    canEdit={editRequest}
                    change={form.change}
                    values={values}
                    isMobileVersion={isMobileVersion}
                  />
                </Grid>
                {!isViewerExpert && (
                  <Grid
                    item
                    md={4}
                    sm={12}
                    style={{
                      position: 'sticky',
                      top: 0,
                      height: '100%',
                      marginTop: '150px',
                    }}
                  >
                    <SubmitContainer disabled={!editRequest} />
                  </Grid>
                )}
              </Grid>
            </form>
          )}
        </Form>
      </div>
    );
  }

  return (
    <>
      {content}

      <AttachToExpertRequest
        open={openAttachToExpertRequest}
        consultation={consultation}
        onConfirm={handleAttachToExpertRequest}
        onCancel={() => setOpenAttachToExpertRequest(false)}
      />
    </>
  );
};

export default connector(ExpertRequestDetails);
